/* eslint-disable max-len */
const texts = {
  title: 'Lead Disqualification and Direct Purchase',
  pageLoadOfferMessageText: 'Message for Country-Blocked Leads (Page Load)',
  pageLoadOfferMessageTextPlaceholder: 'Enter the message shown when a lead is disqualified by country before starting the form.',
  pageLoadOfferMessageHelperText: 'Shown when the lead\'s country is disqualified on page load, alongside the direct purchase link.',
  postSubmissionOfferMessageText: 'Message for Disqualified Leads (After Form Submission)',
  postSubmissionOfferMessageTextPlaceholder: 'Enter the message shown when a lead is disqualified after submitting the form.',
  postSubmissionOfferMessageHelperText: 'Shown after form submission when the lead is disqualified, alongside the direct purchase link.',
  directPurchaseLink: 'Direct Purchase Contract',
  directPurchaseLinkHelperText: 'This contract will be attached to both offer messages above.',
  selectContract: 'Select a direct purchase contract',
  setupDirectPurchaseLink: 'Set Up Direct Purchase Contract',
  disqualifiedCountries: 'Disqualified Countries (Coach Level)',
  disqualifiedCountriesPlaceholder: 'e.g. United States, Canada, Australia',
  disqualifiedCountriesNote: 'Leads from these countries will be disqualified before they begin the form. Separate with commas.',
  save: 'Save Changes',
  saved: 'Direct purchase settings saved successfully.',
  offerMessageRequired: 'Both disqualification messages are required when a direct purchase contract is selected.',
  saveError: 'Failed to save direct purchase configuration. Please try again.',
  pageLoadDisqualificationOfferMessage: 'Thanks for your interest in my coaching. Subscribe below to get started today!',
  postSubmissionDisqualificationOfferMessage: 'Based on your answers you\'re qualified to enroll. Subscribe below to get started today!',
};

export default texts;
